module.exports = __webpack_public_path__ + "static/q12_o-0a43cf74f0e61d8f58a763e711a0e592.png";